import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { CLIENT_ACTIVITIES } from '../../../common/constants/routingConstants'
import { useAppDispatch } from '../../../data/store'
import { setSelectedClientId } from '../../clients/clientDetails/data/ltClientSlice'

const useNavigateToClientAssignment = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  return useCallback(
    (clientId: string, assignmentId: string) => {
      dispatch(setSelectedClientId(clientId))
      navigate(`${CLIENT_ACTIVITIES.route}?assignmentId=${assignmentId}`)
    },
    [dispatch, navigate],
  )
}

export default useNavigateToClientAssignment
